module.exports = __webpack_public_path__ + "res/Roboto-ThinItalic-webfont.eot?6be6cc4afd3acbbe3096590d7ed9241d";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/roboto/Roboto-ThinItalic-webfont.eot
// module id = 61
// module chunks = 0